import {Component, Input, OnInit, NgZone, ViewChild, ElementRef} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {CartService} from "../../services/cart.service";
import {iDefaultPaymentModes, iDeliveryModes, iInpost, iPPoint, iSelectedPPoint, iDPDPoint, iSupportedPaymentModes} from "../../model/CartModel";
import {DeliveryMethod} from "../../model/enums/Delivery.enum";
import {ScriptLoaderService} from "../../services/scripts.service";
import {Observable, Subscription} from "rxjs";
declare const window: any;

@ComponentAsElement('v-cart-delivery-payment-element')
@Component({
  selector: 'v-cart-delivery-payment',
  templateUrl: './cart-delivery-payment.component.html'
})
export class CartDeliveryPaymentComponent implements OnInit {
  @Input() asmMode: string;
  @Input() site: string;
  @Input() apiKey: string;
  @ViewChild('cartDelivery') deliverySection: ElementRef;
  @ViewChild('cartPayment') paymentSection: ElementRef;
  deliveryModes: false|iDeliveryModes[];
  cart$: Observable<string|iDeliveryModes[]>;
  payments$: Observable<string | (iDefaultPaymentModes | iSupportedPaymentModes)[]>;
  subscriptions: Subscription = new Subscription;
  selectedDelivery = '';
  selectedPayment = '';
  selectedPos = null;
  isPosSelected = '';
  deliveryError: boolean;
  paymentError: boolean;
  posError = '';
  selectedInpost: null|iInpost;
  runInpost = false;
  runDPD = false;
  inpostError = false;
  selectedPP: null|iSelectedPPoint;
  selectedOtherPP: null|iSelectedPPoint;
  selectedPPType: string;
  postOrlenZabkaError = false;
  postOthersError = false;
  selectedDPDPickup: null|iDPDPoint;
  dpdPickupError = false;
  deliverySubmitted = false;
  paymentSubmitted = false;
  PPWidgetTypes = {
    orlen: ['ORLEN', 'ZABKA'],
    others: ['POCZTA', 'AUTOMAT_POCZTOWY', 'RUCH', 'FRESHMARKET', 'AUTOMAT_BIEDRONKA', 'AUTOMAT_CARREFOUR', 'AUTOMAT_PLACOWKA', 'AUTOMAT_LEWIATAN', 'AUTOMAT_SPOLEM']
  }
  deliveryMethod = DeliveryMethod;
  payuInstallmentWidget = false;

  constructor(private cartService: CartService, private ngZone: NgZone, private scriptLoaderService: ScriptLoaderService) {}

  ngOnInit() {
    this.cart$ = this.cartService.initCart;
    this.payments$ = this.cartService.paymentsModes;
    this.cartService.paymentsModes.subscribe((payments: iDefaultPaymentModes[]) => {
      const isInstallment = [...payments].some(payment => payment.code === 'payu_installment');
      isInstallment && this.installementPayu();
      this.paymentSubmitted = false;
    });

    this.subscriptions.add(
      this.cartService.selectedSettings.subscribe(_settings => {
        const settings = _settings;

        this.deliverySubmitted = false;
        if(settings) {
          if(settings.selectedDeliveryModeCode){
            this.selectedDelivery = settings.selectedDeliveryModeCode
          }

          if(settings.selectedPostPickupAddress) {
            this.selectedPPType = settings.selectedDeliveryModeCode;
            if(settings.selectedDeliveryModeCode === DeliveryMethod.pocztaPolskaOrlenZabka) this.selectedPP = settings.selectedPostPickupAddress
            if(settings.selectedDeliveryModeCode === DeliveryMethod.pocztaPolskaOthers) this.selectedOtherPP = settings.selectedPostPickupAddress;
          }

          settings.selectedDPDPickupAddress && (this.selectedDPDPickup = settings.selectedDPDPickupAddress) && this.scrollTo(this.deliverySection, 'start');
          settings.selectedPaymentModeCode ? this.selectedPayment = settings.selectedPaymentModeCode : this.selectedPayment = '';
        }
      })
    );

    window['angularCartComponentReference'] = {
      component: this,
      zone: this.ngZone,
      cartDeliveryPaymentValidate: (_formId) => this.validate(_formId)
    };
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  validate(_formId) {
    const  formId = _formId;

    if(!this.selectedDelivery) {
      if(this.deliveryError) {
        this.scrollTo(this.deliverySection);
      }
      this.deliveryError = true;
    }
    else if(!this.selectedPos && (this.selectedDelivery === DeliveryMethod.pickup || this.selectedDelivery === DeliveryMethod.asmPickup)) {
      if(this.posError) {
        this.scrollTo(this.deliverySection);
      }
      this.posError = this.isPosSelected;
    }
    else if(!this.selectedInpost && this.selectedDelivery.includes(DeliveryMethod.inpost)) {
      if(this.inpostError) {
        this.scrollTo(this.deliverySection);
      }
      this.inpostError = this.selectedInpost ? false : true;
    }
    else if(this.selectedPPType !== this.selectedDelivery && this.selectedDelivery.includes(DeliveryMethod.pocztaPolskaOrlenZabka)) {
      if(this.postOrlenZabkaError) {
        this.scrollTo(this.deliverySection);
      }
      this.postOrlenZabkaError = this.selectedPPType === this.selectedDelivery && this.selectedPP ? false : true;
    }
    else if(this.selectedPPType !== this.selectedDelivery && this.selectedDelivery.includes(DeliveryMethod.pocztaPolskaOthers)) {
      if(this.postOthersError) {
        this.scrollTo(this.deliverySection);
      }
      this.postOthersError = this.selectedPPType === this.selectedDelivery  && this.selectedPP ? false : true;
    }
    else if(!this.selectedDPDPickup && this.selectedDelivery.includes(DeliveryMethod.dpdPickup)) {
      if(this.dpdPickupError) {
        this.scrollTo(this.deliverySection);
      }
      this.dpdPickupError =  this.selectedDPDPickup ? false : true;
    }
    else if(!this.selectedPayment) {
      if(this.paymentError) {
        this.scrollTo(this.paymentSection);
      }
      this.paymentError = true;
    }
    else {
      const form = <HTMLFormElement>document.getElementById(formId);
      const button = <HTMLInputElement>form.querySelector('[type="submit"]');
      const parent = <HTMLDivElement>document.getElementById('cartSummary-submitButton')

      this.deliverySubmitted = true;
      this.paymentSubmitted = true;
      parent.classList.add('--disabled')
      button.disabled = true;
      window.spinnerElement.show(parent);
      form.submit();
    }
  }

  changeDelivery(_delivery) {
    const delivery = _delivery;

    if(this.selectedDelivery === delivery || this.deliverySubmitted) return;

    this.triggerGACheckoutOption("1", delivery);
    this.selectedPayment = '';

    switch(delivery) {
      case DeliveryMethod.pickup:
      case DeliveryMethod.asmPickup:
        if(this.selectedPos) {
          this.triggerDelivery(delivery,'pickup', this.selectedPos.name);
        }
        else {
          this.paymentSubmitted = true;
          this.selectedDelivery = delivery;
          this.deliveryError = false;
          this.paymentError = false;
        }
        break;
      case DeliveryMethod.standard:
      case DeliveryMethod.asmStardard:
      case DeliveryMethod.asmStandardFree:
      case DeliveryMethod.asmCrossBoroder:
        this.triggerDelivery(delivery,'dpd', delivery);
        break;
      case DeliveryMethod.pharmaLink:
        this.triggerDelivery(delivery,'pharmalink');
        break;
      case DeliveryMethod.email:
        this.triggerDelivery(delivery,'email');
        break;
      case DeliveryMethod.inpost:
      case DeliveryMethod.asmInpost:
        this.runInpost = true;
        if(this.selectedInpost) {
          this.triggerDelivery(delivery,'inpost', this.selectedInpost);
        }
        else {
          this.paymentSubmitted = true;
          this.selectedDelivery = delivery;
          this.deliveryError = false;
          this.paymentError = false;
        }
        break;
      case DeliveryMethod.pocztaPolskaOrlenZabka:
        if(this.selectedPP) {
          this.triggerDelivery(delivery,delivery, this.selectedPP)
        }
        else {
          this.paymentSubmitted = true;
          this.triggerPPWidget(delivery, this.PPWidgetTypes.orlen);
          this.selectedDelivery = delivery;
        }
        break;
      case DeliveryMethod.pocztaPolskaOthers:
        if(this.selectedOtherPP) {
          this.triggerDelivery(delivery,delivery, this.selectedOtherPP)
        }
        else {
          this.paymentSubmitted = true;
          this.triggerPPWidget(delivery, this.PPWidgetTypes.others);
          this.selectedDelivery = delivery;
        }
        break;
      case DeliveryMethod.dpdPickup:
        this.runDPD = true;
        if(this.selectedDPDPickup) {
          this.triggerDelivery(delivery,delivery, this.selectedDPDPickup.name);
        }
        else {
          this.paymentSubmitted = true;
          this.selectedDelivery = delivery;
          this.paymentError = false;
        }
        break;
    }
  }

  triggerPPWidget(_delivery, _types) {
    const delivery = _delivery;
    const types = _types;

    window.PPWidgetApp?.toggleMap({callback: (point) => this.definePPoint(point, delivery), type:types});
  }

  triggerDelivery(_element, _delivery, _code?) {
    this.deliverySubmitted = true;
    this.paymentSubmitted = true;
    this.cartService.changeDelivery(_delivery, _code)
      .subscribe(() => {
        this.selectedDelivery = _element;
        this.deliveryError = false;
        this.paymentError = false;
        this.deliverySubmitted = false;
        this.paymentSubmitted = false;
      });
  }

  choosePayment(_payment, _enabled) {
    const payment = _payment;
    const enabled = _enabled;

    if(!enabled || this.selectedPayment === payment || this.paymentSubmitted) return;
    this.paymentSubmitted = true;
    this.deliverySubmitted = true;

    this.cartService.choosePayment(payment).subscribe(() => {
      this.selectedPayment = payment;
      this.paymentError = false;
      this.triggerGACheckoutOption("2", payment);
      this.paymentSubmitted = false;
      this.deliverySubmitted = false;
    });
  }

  setPos(_selectedPos) {
    this.selectedPos = _selectedPos;
  }

  setInpost(_selectedInpost) {
    const selected = _selectedInpost;

    this.selectedInpost = selected;
    this.paymentError = false;
  }

  setDPDPointCode(_selectedDPDPointCode) {
    const code = _selectedDPDPointCode;

    this.selectedDPDPickup = null;
    this.triggerDelivery(DeliveryMethod.dpdPickup, DeliveryMethod.dpdPickup, code);
  }

  setIsPosSelected(_selected) {
    const selected = _selected;

    this.isPosSelected = selected;
  }

  definePPoint(_point: iPPoint, _delivery) {
    const delivery = _delivery;
    const {name, zipCode: postCode, city: town} = _point;
    let {street} = _point;

    if(street.startsWith('ul.')) street = street.slice(4);
    this.selectedPPType = delivery;
    this.triggerDelivery(delivery,_delivery, {name, street, postCode, town});
    if(delivery === DeliveryMethod.pocztaPolskaOrlenZabka) this.postOrlenZabkaError = false;
    if(delivery === DeliveryMethod.pocztaPolskaOthers) this.postOthersError = false;
  }

  setDPDPoint(_point) {
    const point = _point;

    this.selectedDPDPickup = point;
    this.paymentError = false;
  }

  scrollTo(_element, position = 'center') {
    const element = _element;

    element.nativeElement.scrollIntoView({block: 'center', behavior: 'smooth'});
  }

  async installementPayu() {
    try {
      await this.scriptLoaderService.load('payu-installament');
      this.payuInstallmentWidget = true;
    }
    catch (err) {
      console.error(err)
    }
  }

  triggerGACheckoutOption(step, option) {
    const dataLayer = window['dataLayer'];
    if(typeof(dataLayer) !== "undefined") {
      dataLayer.push({
          "event": "checkoutOption",
          "ecomm_pagetype": "Basket",
          "ecommerce": {
            "checkout_option": {
              'actionField': {
                'step': step,
                'option': option
              }
            }
          }
      });
    }
  }
}
